(function(angular) {
	'use strict';

	angular
		.module('investorDashboard', [
			'apiModule',
			'beneficiaryAlertModule',
			'bigModule',
			'cancelRedemptionRequestModalModule',
			'cancelTransactionModalModule',
			'changeBankAccountModalModule',
			'collapseModule',
			'coreModule',
			'featuresModule',
			'investmentGoalChartModule',
			'hypotheticalPerformanceChartModule',
			'ipoSharePriceChartModule',
			'localStorageModule',
			'newsFeedModule',
			'ngCookies',
			'planModule',
			'portfolioAllocationChartModule',
			'revealModule',
			'riskAdjustedReturnModule',
			'serviceLevelModule',
			'stateOfResidencyModalModule',
			'transactionActivityTableModule'
		])
		.filter('returnFigure', [ '$filter', function($filter) {
			return function(input, format) {
				if(angular.isDefined(input)) {
					if(format === 'returnAsPercentage') {
						return $filter('percentage')(input.returnAsPercentage, '1');
					} else {
						return $filter('currency')(input.returnAsCurrency, '$');
					}
				} else {
					return '';
				}
			};
		}])
		.value('globalConfig', globalConfig);
})(window.angular);
